export default "__VITE_ASSET__DHeVl1B9__"